import { Box, Typography, TypographyProps } from "@mui/material";
import { Link } from "react-router-dom";

type Props = {
  to: string;
  text: string;
  TypographyProps?: TypographyProps;
  stopPropagation?: boolean;
};

const NewTabLink = ({
  to,
  text,
  TypographyProps = {},
  stopPropagation = false,
}: Props) => {
  return (
    <Link
      to={to}
      style={{ textDecoration: "none", display: "block", width: "100%" }}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        if (stopPropagation) {
          e.stopPropagation();
        }
      }}
    >
      <Box display="flex" alignItems="center" gap="4px">
        <Typography
          variant="header"
          {...TypographyProps}
          sx={{
            color: (theme) => theme.palette.primary.main,
            ...(TypographyProps?.sx || {}),
          }}
        >
          {text}
        </Typography>
      </Box>
    </Link>
  );
};

export default NewTabLink;
